<template>
  <b-modal
    id="add-product-modal"
    ref="addProductModalRef"
    :size="modalSize"
    @hidden="resetModal"
    :hide-footer="tabIndex !== 0"
  >
    <template v-slot:modal-header="{ close }">
      <div class="title">ADD PRODUCT ∙ {{ layerDisplayName }}</div>
      <b-link class="modal-close-link float-right" right @click="close()">
        <i class="pe-7s-close close-icon"></i>
      </b-link>
    </template>

    <div class="box pt-4 pb-4">
      <div class="box-part" id="bp-left">
        <b-tabs v-model="tabIndex" class="nav-justified">
          <b-tab title="From URL" title-link-class="form-tab-link">
            <div class="partition">
              <FromUrl />
            </div>
          </b-tab>

          <b-tab title="From Wardrobe" title-link-class="form-tab-link">
            <div class="partition">
              <FromWardrobe :layer-display-name="layerDisplayName" />
            </div>
          </b-tab>
        </b-tabs>
      </div>
    </div>

    <template v-slot:modal-footer>
      <div class="wrapper w-100" v-b-toggle.collapse-supported-sites>
        <div class="supporting-sites">
          <span>Partners</span>
          <i class="pe-7s-angle-down expand-icons"></i>
        </div>

        <b-collapse visible id="collapse-supported-sites">
          <BrandsDisplay class="mt-4 mb-4" />
        </b-collapse>
      </div>
    </template>
  </b-modal>
</template>

<script>
import BrandsDisplay from "@/components/brandsDisplay";
import FromUrl from "@/components/capsuleBuilder/modals/addProductModal/FromUrl";
import FromWardrobe from "@/components/capsuleBuilder/modals/addProductModal/FromWardrobe";
import { mapActions, mapGetters } from "vuex";
import { bus } from "@/main";

export default {
  name: "AddProductModal",

  components: {
    BrandsDisplay,
    FromUrl,
    FromWardrobe,
  },

  data() {
    return {
      tabIndex: 0,
      capsuleId: null,
      layerDisplayName: null,
      layerId: null,
    };
  },

  mounted() {
    bus.$on("openAddItemModal", (params) => {
      if (this.$refs.addProductModalRef) {
        this.resetData(params);
        this.restEagerCreateProductResponse();
        this.$nextTick(() => this.$bvModal.show("add-product-modal"));
      }
    });

    bus.$on("submitAddCapsuleLayerProduct", (params) => {
      const payload = {
        capsuleId: this.capsuleId,
        layerId: this.layerId,
        ...params,
      };

      this.addCapsuleLayerProduct(payload);

      this.$nextTick(() => this.$bvModal.hide("add-product-modal"));
    });
  },

  methods: {
    ...mapActions(["addCapsuleLayerProduct", "restEagerCreateProductResponse"]),

    resetModal() {
      this.tabIndex = 0;
    },

    resetData(params) {
      this.capsuleId = params.capsuleId;
      this.layerDisplayName = params.layerDisplayName;
      this.layerId = params.layerId;
      this.tabIndex = 0;
    },
  },

  computed: {
    modalSize() {
      return this.tabIndex === 0 ? "md" : "xl";
    },
  },
};
</script>
<style lang="scss">
@import "~@/styles/_colour-palette.scss";
@import "~@/styles/_modal_add_item_btn.scss";
@import "~@/styles/_breakpoints.scss";

#add-product-modal {
  .partition {
    margin-top: 30px;
  }

  .nav-item {
    &:first-child {
      text-align: center;

      .nav-link {
        padding-right: 0px;
      }

      @include for-tablet-landscape-up {
        text-align: right;

        .nav-link {
          padding-right: 50px;
        }
      }
    }

    &:last-child {
      text-align: center;

      .nav-link {
        padding-left: 0px;
      }

      @include for-tablet-landscape-up {
        text-align: left;

        .nav-link {
          padding-left: 50px;
        }
      }
    }
  }

  .form-tab-link {
    padding: 15px;
    font-weight: 400;
    font-size: 1rem;
    text-transform: uppercase;
    letter-spacing: 1px;
    color: $primary-accent !important;
    border: none !important;
    border-bottom: 3px solid $primary-accent !important;

    @include for-sm-phone-only {
      padding: 10px;
      font-size: 0.9rem;
    }

    &:not(.active) {
      font-weight: 300;
      color: #999 !important;
      border-color: #999 !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/capsuleBuilder/modals/AddProductModal.vue